import { fetchUnauthorised } from '@mbrc/routing';
import { PROJECTS_URL, SERVICES_FILE_NAME } from './appSettings';
import { GetProjectsResponse, ManifestDto } from './externalDtos';
import { memberDetails, memberName } from './ajax';

export const getMember = () : Promise<boolean> => 
memberDetails();

export const getMemberName = () : Promise<string> =>
memberName();

export const getProjects = () : Promise<GetProjectsResponse> =>
fetchUnauthorised({method: 'GET', url: PROJECTS_URL+SERVICES_FILE_NAME});

export const getManifest = (manifestUrl: string) : Promise<ManifestDto> =>
  fetchUnauthorised({method: 'GET', url: manifestUrl}).then(resBody => {
    var trimmed = resBody.replace(/.+?{/, "{");
    var decoded = utf16ToText(trimmed);
    var parsed = JSON.parse(decoded);
    return parsed;
  });

  const utf16ToText = (input: string) => {
    var cp = [];
    for( var i = 0; i < input.length; i+=2) {
        cp.push( 
          input.charCodeAt(i) |
            ( input.charCodeAt(i+1) << 8 )
        );
    }

    return String.fromCharCode.apply( String, cp );
  }

